import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'

interface ProfileTotals {
  posts_count: number
  connections_count: number
  pending_connections_count: number
  achievements_count: number
  recognitions_count: number
  statistics_count: number
  is_own_profile: boolean
}

export const useProfileTotals = (userId: string) => {
  return useQuery({
    queryKey: ['profile-totals', userId],
    queryFn: async (): Promise<ProfileTotals> => {
      // Get session to ensure we have a valid token
      const { data: { session }, error: sessionError } = await supabase.auth.getSession()
      if (sessionError || !session) {
        throw new Error('User not authenticated')
      }

      const { data, error } = await supabase.functions.invoke('get_profile_totals', {
        body: { target_user_id: userId }
      })

      if (error) {
        throw new Error(error.message)
      }

      return data
    },
    enabled: !!userId,
    staleTime: 0, // Always consider data stale
    gcTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true
  })
} 